import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type BannerAnnouncementStore = {
  dismissedBannerIds: string[];
  dismissBanner: (id: string) => void;
  bannerHeight: number;
  setBannerHeight: (height: number) => void;
};

export const useBannerAnnouncementStore = create<BannerAnnouncementStore>()(
  persist(
    (set) => ({
      dismissedBannerIds: [],
      dismissBanner: (id) =>
        set((state) => ({
          dismissedBannerIds: state.dismissedBannerIds.includes(id)
            ? state.dismissedBannerIds
            : [...state.dismissedBannerIds, id],
        })),
      bannerHeight: 0,
      setBannerHeight: (height) => set({ bannerHeight: height }),
    }),
    {
      name: 'dismissed-banner-ids',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ dismissedBannerIds: state.dismissedBannerIds }),
    },
  ),
);
